module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-309.8b4ca16f.png";